export const CLEAR_INDUSTRY_MANAGEMENT_STATE = 'CLEAR_INDUSTRY_MANAGEMENT_STATE';

export const GET_ALL_INDUSTRYS = 'GET_ALL_INDUSTRYS';
export const GET_ALL_INDUSTRYS_SUCCESS = 'GET_ALL_INDUSTRYS_SUCCESS';
export const GET_ALL_INDUSTRYS_ERROR = 'GET_ALL_INDUSTRYS_ERROR';

export const GET_INDUSTRY_BY_ID = 'GET_INDUSTRY_BY_ID';
export const GET_INDUSTRY_BY_ID_SUCCESS = 'GET_INDUSTRY_BY_ID_SUCCESS';
export const GET_INDUSTRY_BY_ID_ERROR = 'GET_INDUSTRY_BY_ID_ERROR';

export const CREATE_INDUSTRY = 'CREATE_INDUSTRY';
export const CREATE_INDUSTRY_SUCCESS = 'CREATE_INDUSTRY_SUCCESS';
export const CREATE_INDUSTRY_ERROR = 'CREATE_INDUSTRY_ERROR';

export const UPDATE_INDUSTRY = 'UPDATE_INDUSTRY';
export const UPDATE_INDUSTRY_SUCCESS = 'UPDATE_INDUSTRY_SUCCESS';
export const UPDATE_INDUSTRY_ERROR = 'UPDATE_INDUSTRY_ERROR';

export const DELETE_INDUSTRY = 'DELETE_INDUSTRY';
export const DELETE_INDUSTRY_SUCCESS = 'DELETE_INDUSTRY_SUCCESS';
export const DELETE_INDUSTRY_ERROR = 'DELETE_INDUSTRY_ERROR';
